import FeatureSwitchCheck from "./FeatureSwitchCheck";


export class BooleanFlag extends FeatureSwitchCheck<boolean> {

    protected parseFeatureValue(featureSwitchValue: string | undefined): boolean {
        return featureSwitchValue?.toLowerCase() === "true";
    }

    protected doCheck(featureValue: boolean): boolean {
      return featureValue ?? false;
    }

}
